__turbopack_context__.v({
  "formField": "IO8OyG_formField",
  "formFieldHorizontalLabel": "IO8OyG_formFieldHorizontalLabel",
  "formFieldLabel": "IO8OyG_formFieldLabel",
  "messageContainer": "IO8OyG_messageContainer",
});
